export default function ShippingExpressIcon() {
  return (
    <>
      <g id='Frame' clipPath='url(#clip0_3720_226301)'>
        <path
          id='Vector'
          d='M6.67188 22.6667C6.67188 23.3739 6.95283 24.0522 7.45292 24.5523C7.95302 25.0524 8.6313 25.3333 9.33854 25.3333C10.0458 25.3333 10.7241 25.0524 11.2242 24.5523C11.7243 24.0522 12.0052 23.3739 12.0052 22.6667C12.0052 21.9594 11.7243 21.2811 11.2242 20.781C10.7241 20.281 10.0458 20 9.33854 20C8.6313 20 7.95302 20.281 7.45292 20.781C6.95283 21.2811 6.67188 21.9594 6.67188 22.6667Z'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M20 22.6667C20 23.3739 20.281 24.0522 20.781 24.5523C21.2811 25.0524 21.9594 25.3333 22.6667 25.3333C23.3739 25.3333 24.0522 25.0524 24.5523 24.5523C25.0524 24.0522 25.3333 23.3739 25.3333 22.6667C25.3333 21.9594 25.0524 21.2811 24.5523 20.781C24.0522 20.281 23.3739 20 22.6667 20C21.9594 20 21.2811 20.281 20.781 20.781C20.281 21.2811 20 21.9594 20 22.6667Z'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M6.66667 22.6719H4V8.00521C4 7.65159 4.14048 7.31245 4.39052 7.0624C4.64057 6.81235 4.97971 6.67188 5.33333 6.67188H17.3333V22.6719M12 22.6719H20M25.3333 22.6719H28V14.6719M28 14.6719H17.3333M28 14.6719L24 8.00521H17.3333'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3720_226301'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </>
  );
}
